import { configureStore } from "@reduxjs/toolkit";
import languageReducer from "./LanguageSlice";
import adminReducer from "./adminReducer"
export const store = configureStore({
  reducer: {
    language: languageReducer,
    admin:adminReducer
  },
});
